import React from 'react'

export function TimeIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='12' cy='13' r='9' stroke='currentColor' strokeWidth='2' />
      <path stroke='currentColor' strokeWidth='2' d='M8 1h8M12 7v7M19.707 4.707l-2 2' />
    </svg>
  )
}
